import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonConstant } from '@app/common/constant/common.constant';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { ProductState, getSpecialProducts } from '@app/selectors/shoppingmall/product.selector';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

declare const recomProductSwiper: any;

@Component({
  selector: 'hp-pick',
  templateUrl: './hp-pick.component.html',
  styleUrls: ['./hp-pick.component.css']
})
export class HpPickComponent implements OnInit {
  @Input() 
  urlWownet : string = "";

  @Output() 
  itemProduct = new EventEmitter<OrdPdtModel>();

  products$ = new Observable<OrdPdtModel[]>();
  products: OrdPdtModel[] = [];
  recommMenus: string[] = [];
  
  constructor(private _productStore: Store<ProductState>) { 
    this.products$ = this._productStore.select(getSpecialProducts);
  }

  ngOnInit(): void {
    this.products$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.products = res.filter(x=> x.recommYN === CommonConstant.YES);

        let length = this.products.length;
        this.recommMenus = new Array(length);

        for(let i = 0; i < length; i++) {
          if(i < 5) {
            this.recommMenus[i] = ConvertUtil.convertToString(this.products[i].pdtName);
          }          
        }

        setTimeout(() => {
          recomProductSwiper(this.recommMenus);
        }, 500);
      }
    });
  }

  handleOnClickProductDetail(item: any): void {
    this.itemProduct.emit(item);
  }
}
